<template>
    <div class="stats-component" :class="mode == 'dark' ? 'dark' : 'light'">
        <section class="uk-section uk-section-small">
            <div class="uk-child-width-1-3@s" uk-grid>
                <p class="uk-text-center">Farm Price: <span>217.62 USD</span></p>
                <p class="uk-text-center">Profit Sahre APY: <span>219.18%</span></p>
                <p class="uk-text-center">Market cap: <span>49.26M USD</span></p>
            </div>  
        </section>
    </div>    
</template>

<script>
export default {
    name: 'Stats',
    props: {
        mode: String
    }
}
</script>

<style lang="less" scoped>
    @import "../../dark-components/stats.less";

    p {
        font-family: 'Lato';
        font-weight: 700;
        .fluid-font(1, 30, 320, 3840);
        color: @text-color;
    }

</style>